<template>
  <section class="section hero">
    <div class="container">
      <h3 class="hero__subtitle">Вітаємо Вас на сторінці голосування</h3>
      <h1 class="large-title hero__title">Grand Imperial Europe 2026</h1>
      <div class="hero__txt">
        <p>
          «Grand Imperial Europe 2026» — це більше, ніж конкурс краси. Це свято
          жіночої сили, впевненості та досягнень. Подія, яка відкриває нові
          можливості, дарує визнання та підкреслює статус сучасної української
          жінки. Учасниці отримують унікальну можливість представити себе на
          міжнародних конкурсах краси.
        </p>
      </div>
      <div class="hero__txt">
        <p>
          Метою конкурса є популяризації української жіночої вроди, як в
          Україні, так і за її межами, адже наші переможці є фіналістками
          світових конкурсів краси.
        </p>
      </div>
      <!-- <div class="hero__txt">
        <p>*Частина зібраних коштів буде спрямована на ЗСУ</p>
      </div> -->
    </div>
  </section>
</template>
